import { ENDPOINTS } from 'hammock';
import React, { useEffect, useState } from 'react';

import { httpRequest } from '@candu-ai/commons/network';
import { DropdownBox } from 'craft/containers/Toolbox/components';

interface Trait {
  field: string;
  name: string;
}

// TODO: maybe use hammock?
const completionsEndpoint = `${ENDPOINTS.autoComplete}?finder=byUserTraits`;

interface TraitSelectProps {
  value?: string;
  label?: string;
  onChange: (trait: string) => void;
}

export const TraitSelect = ({ value, onChange, label }: TraitSelectProps) => {
  const [traits, setTraits] = useState<string[]>([]);
  const [selectedTrait, setSelectedTrait] = useState<string>(value || '');

  useEffect(() => {
    httpRequest(completionsEndpoint)
      .then((response) => response.json())
      .then((data) => {
        setTraits(data.map((trait: Trait) => trait.name));

        // if there is no value selected set a default
        // prefer organizationId, only if it exists in the available traits
        if (!value) {
          const organizationIdExists = data.find((trait: Trait) => trait.name === 'organizationId');
          if (organizationIdExists) {
            setSelectedTrait('organizationId');
          } else {
            setSelectedTrait(data[0].name);
          }
        }
      });
  }, []);

  return (
    <DropdownBox
      value={selectedTrait}
      onChange={(selectedValue: string) => {
        setSelectedTrait(selectedValue);
        onChange(selectedValue);
      }}
      options={traits.map((trait) => ({ name: trait, value: trait }))}
      label={label}
      trackingId="trait-select"
    />
  );
};
